module.exports = __webpack_public_path__ + "static/media/KN.73245a20.png";